<template>
  <Box class="box-container">
    <div class="header">
      <h3>Aulas</h3>

      <MiniSelect :options="months" :modelValue="selectedMonth" @update:modelValue="updateModelValue"
        :disabled="loadingPraticas || loadingTeoricas" />
    </div>

    <div class="content">
      <div class="infos">
        <div class="info-badge">
          <span class="primary">Téoricas</span>
        </div>

        <div v-if="loadingTeoricas" class="loading">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
          </component>
        </div>

        <template v-else>
          <PieChart v-if="teoricasInfosForChart.length" class="chart" :data="teoricasInfosForChart" idForChart="teoricasPieChart" />
          <PieChart v-else class="chart" idForChart="teoricasPieChart" />
        </template>
      </div>

      <div class="infos">
        <div class="info-badge">
          <span class="success">Práticas</span>
        </div>

        <div v-if="loadingPraticas" class="loading">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
          </component>
        </div>

        <template v-else>
          <PieChart v-if="praticasInfosForChart.length" class="chart" :data="praticasInfosForChart" idForChart="praticasPieChart" />
          <PieChart v-else class="chart" idForChart="praticasPieChart" />
        </template>
      </div>

      <div class="infos">
        <div class="info-badge">
          <span>Agendadas Hoje</span>
        </div>

        <div v-if="loadingAgendadas" class="loading">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
          </component>
        </div>

        <div v-else class="infos-item">
          <span>{{ agendadas.total_aulas_praticas }} Aulas práticas (Total)</span>
          <span>{{ agendadas.total_aulas_praticas_a }} Aulas Práticas Categoria A</span>
          <span>{{ agendadas.total_aulas_praticas_b }} Aulas Práticas Categoria B</span>
          <span>{{ agendadas.total_aulas_teoricas }} Aulas Teóricas Agendadas</span>
          <span>{{ agendadas.total_turmas_teoricas }} Turmas Agendadas</span>
        </div>
      </div>
    </div>
  </Box>
</template>

<script>
import * as spinners from 'epic-spinners';
import Box from '../core/Box.vue';
import MiniSelect from '../core/MiniSelect.vue';
import PieChart from './PieChart.vue';
import urlApi from '@/router/urlApiV2';

export default {
  name: 'RankInstrutores',
  components: {
    ...spinners,
    Box,
    MiniSelect,
    PieChart,
  },
  data() {
    return {
      teoricasInfos: '',
      praticasInfos: '',
      agendadas: '',
      loadingAgendadas: true,
      loadingTeoricas: true,
      loadingPraticas: true,
      months: [
        { text: 'Janeiro', value: 'january' },
        { text: 'Fevereiro', value: 'february' },
        { text: 'Março', value: 'march' },
        { text: 'Abril', value: 'april' },
        { text: 'Maio', value: 'may' },
        { text: 'Junho', value: 'june' },
        { text: 'Julho', value: 'july' },
        { text: 'Agosto', value: 'august' },
        { text: 'Setembro', value: 'september' },
        { text: 'Outubro', value: 'october' },
        { text: 'Novembro', value: 'november' },
        { text: 'Dezembro', value: 'december' }
      ],
      selectedMonth: '',
    }
  },
  async mounted() {
    this.selectedMonth = this.currentMonth

    this.loadAgendadas()
    this.loadPraticasResume(this.selectedMonth)
    this.loadTeoricasResume(this.selectedMonth)
  },
  methods: {
    async updateModelValue(e) {
      if (e.target.value) {
        this.selectedMonth = e.target.value

        this.loadPraticasResume(e.target.value)
        this.loadTeoricasResume(e.target.value)
      } else {
        this.selectedMonth = this.currentMonth
  
        this.loadPraticasResume(this.selectedMonth)
        this.loadTeoricasResume(this.selectedMonth)
      }
    },
    async loadPraticasResume(month) {
      this.loadingPraticas = true

      await this.$http.get(`${urlApi}/aulas/praticas/relatorio/resumo?month=${month}`)
        .then((response) => {
          this.praticasInfos = response.body.dados
        })
        .catch((err) => {
          this.launchToast('fa-exclamation', err.data.dados)
        })
        .finally(() => {
          this.loadingPraticas = false
        })
    },
    async loadTeoricasResume(month) {
      this.loadingTeoricas = true

      await this.$http.get(`${urlApi}/aulas/teoricas/relatorio/resumo?month=${month}`)
        .then((response) => {
          this.teoricasInfos = response.body.dados
        })
        .catch((err) => {
          this.launchToast('fa-exclamation', err.data.dados)
        })
        .finally(() => {
          this.loadingTeoricas = false
        })
    },
    async loadAgendadas() {
      this.loadingAgendadas = true

      await this.$http.get(`${urlApi}/dashboard/aulas/agendamentos/aulas-agendadas`)
        .then((response) => {
          this.agendadas = response.body.dados
        })
        .catch((err) => {
          this.launchToast('fa-exclamation', err.data.dados)
        })
        .finally(() => {
          this.loadingAgendadas = false
        })
    },
    launchToast(icon, msg) {
      Vue.toasted.show(msg, {
        icon: icon,
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
  },
  computed: {
    teoricasInfosForChart() {
      if (this.teoricasInfos.aceitas == 0 && this.teoricasInfos.analise == 0 && this.teoricasInfos.recusadas == 0 && this.teoricasInfos.canceladas == 0) {
        return [];
      }

      return [
        {
          value: this.teoricasInfos.aceitas,
          label: 'Aceitas',
          color: '#1CCAB8',
        },
        {
          value: this.teoricasInfos.analise,
          label: 'Em análise',
          color: '#FFD56D',
        },
        {
          value: this.teoricasInfos.recusadas,
          label: 'Recusadas',
          color: '#FF8743',
        },
        {
          value: this.teoricasInfos.canceladas,
          label: 'Canceladas',
          color: '#E1E4E8',
        },
      ]
    },
    praticasInfosForChart() {
      if (this.praticasInfos.aceitas == 0 && this.praticasInfos.analise == 0 && this.praticasInfos.recusadas == 0 && this.praticasInfos.canceladas == 0) {
        return [];
      }

      return [
        {
          value: this.praticasInfos.aceitas,
          label: 'Aceitas',
          color: '#1CCAB8',
        },
        {
          value: this.praticasInfos.analise,
          label: 'Em análise',
          color: '#FFD56D',
        },
        {
          value: this.praticasInfos.recusadas,
          label: 'Recusadas',
          color: '#FF8743',
        },
        {
          value: this.praticasInfos.canceladas,
          label: 'Canceladas',
          color: '#E1E4E8',
        },
      ]
    },
    currentMonth() {
      const date = new Date();
      const currentMonthIndex = date.getMonth();
      return this.months[currentMonthIndex].value;
    }
  },
}
</script>

<style lang="scss" scoped>
.box-container {
  min-height: 21.3125rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .header {
    display: flex;
    align-items: center;
    gap: 1rem;

    h3 {
      margin: 0;
      font-size: 1.375rem;
      font-weight: 700;
      color: #202224;
    }
  }

  .loading {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 2rem;

    .infos {
      min-width: 15.0625rem;
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .infos-item {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        span {
          margin: 0;
          padding: 0.25rem 0.5rem 1.25rem;
          font-size: 1rem;
          font-weight: 700;
          color: #202224;

          &:not(:last-child) {
            border-bottom: 1px solid #EAEAEA;
          }
        }
      }
    }

    .info-badge {
      span {
        padding: 0.25rem 0.625rem;
        border: 1px solid #1C2D5A;
        border-radius: 17px;

        font-size: 0.75rem;
        font-weight: 600;
        color: #1C2D5A;

        &.primary,
        &.success {
          border: 0;
        }

        &.primary {
          background: #EAEFFF;
          color: #5379F1;
        }

        &.success {
          background: #D9FFD6;
          color: #2CAA21;
        }
      }
    }
  }
}
</style>
